import React, { useContext, createContext } from "react";

const MetadataContext = createContext({});

const MetadataProvider = props => <MetadataContext.Provider {...props} />;
export const useMetadata = () => useContext(MetadataContext);

export default MetadataProvider;
